import axios from "axios";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { useMutation } from "@tanstack/react-query";

const setDeleteSchedular = async (params) => {

  const [idscheduler, suiteid] = params;
  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=deleteScheduleWithId&idscheduler=${idscheduler}&suiteid=${suiteid}`,
  );
  return response.data;
};

const useDeleteSchedular = (options = {}) => {
  return useMutation({
    mutationFn: setDeleteSchedular,
    ...options,
  });
};
export default useDeleteSchedular;
